import { PermitFormErrorsContext } from '@src/orders/PermitFormSections/PermitFormErrorsContext';
import { useContext } from 'react';

export const usePermitFormErrors = () => {
  const { formErrorKeys } = useContext(PermitFormErrorsContext);

  return {
    formErrorKeys,
  };
};
